import { useState, useEffect } from 'react'
import { fetchUserSelfcare } from '../utils/user'
import { UserSelfcare } from '../types/user'

export function useUserSelfcare() {
  const [data, setData] = useState<UserSelfcare | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    async function load() {
      setIsLoading(true)
      try {
        const channels = await fetchUserSelfcare()
        setData(channels)
      } catch (err) {
        setError(err as Error)
      } finally {
        setIsLoading(false)
      }
    }
    load()
  }, [])

  return { data, isLoading, error }
}
